import type { TaxBracket, TaxRebate, TaxThresholds, TaxYear } from '../../../types/tax';
import { BaseTaxYearStrategy } from '../TaxYearStrategy';
import {
  TAX_BRACKETS_2025_26,
  TAX_REBATES_2025_26,
  TAX_THRESHOLDS_2025_26,
  ANNUAL_MEDICAL_AID_CREDITS_2025_26,
  TAX_YEAR_2025_26_START,
  TAX_YEAR_2025_26_END
} from '../../../data/tax';

export class TaxYear2025_26Strategy extends BaseTaxYearStrategy {
  getYear(): TaxYear {
    return '2025-26';
  }
  
  getDisplayName(): string {
    return '2025-2026 Tax Year (No Changes)';
  }
  
  getTaxBrackets(): TaxBracket[] {
    return TAX_BRACKETS_2025_26;
  }
  
  getTaxRebates(): TaxRebate {
    return TAX_REBATES_2025_26;
  }
  
  getTaxThresholds(): TaxThresholds {
    return TAX_THRESHOLDS_2025_26;
  }
  
  getMedicalAidCredits(): { mainMember: number; firstDependent: number; additionalDependent: number; } {
    return {
      mainMember: ANNUAL_MEDICAL_AID_CREDITS_2025_26.mainMember,
      firstDependent: ANNUAL_MEDICAL_AID_CREDITS_2025_26.firstDependent,
      additionalDependent: ANNUAL_MEDICAL_AID_CREDITS_2025_26.additionalDependent
    };
  }
  
  getStartDate(): Date {
    return TAX_YEAR_2025_26_START;
  }
  
  getEndDate(): Date {
    return TAX_YEAR_2025_26_END;
  }
}